import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalConfigService } from './global-config.service';

export interface ClinicLocation {
  city: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  clinicCount: number;
  clinicName?: string;
  cnpj?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClinicLocationService {
  private apiUrl: string;

  constructor(private http: HttpClient, private globalConfig: GlobalConfigService) { 
    this.apiUrl = this.globalConfig.getApiUrl();
  }

  /**
   * Busca os dados reais de localização das clínicas do backend
   * Retorna um array de objetos com a estrutura ClinicLocation
   */
  getLocations(): Observable<ClinicLocation[]> {
    return this.http.get<any>(`${this.apiUrl}/companies/locations`)
      .pipe(
        map(response => {
          // Verificar se a resposta é válida
          if (!response || !Array.isArray(response)) {
            throw new Error('Formato de resposta inválido');
          }
          
          // Converter snake_case para camelCase
          return response.map(location => ({
            city: location.city,
            state: location.state,
            country: location.country,
            latitude: location.latitude,
            longitude: location.longitude,
            clinicCount: location.clinic_count,
            clinicName: location.clinic_name,
            cnpj: location.cnpj
          }));
        }),
        catchError((error: HttpErrorResponse) => {
          let errorMsg = 'Erro ao buscar localizações de clínicas';
          
          if (error.error instanceof ErrorEvent) {
            // Erro do lado do cliente
            errorMsg = `Erro de conexão: ${error.error.message}`;
          } else {
            // Erro do lado do servidor
            switch (error.status) {
              case 401:
                errorMsg = 'Não autorizado. Faça login novamente.';
                break;
              case 403:
                errorMsg = 'Acesso proibido a este recurso.';
                break;
              case 404:
                errorMsg = 'Endpoint não encontrado no servidor.';
                break;
              case 500:
                errorMsg = 'Erro interno do servidor.';
                break;
              default:
                errorMsg = `Erro ${error.status}: ${error.statusText}`;
            }
          }
          
          console.error(errorMsg, error);
          throw error; // Propaga o erro para ser tratado pelo componente
        })
      );
  }
}
